import { getAPIFullUrl, getAxiosConfig, handleApiError } from './risapi';
import { risapi } from './risapi';
import { convertJsonToFormData } from '../commonfunctions';

export const getTags = async (filterParameters, callback) => {
    try {
        const response = await risapi.get(getAPIFullUrl('/api/tags', filterParameters), getAxiosConfig());
        if (response.status === 200) {
            callback(response.data);
        }
    } catch (error) {
        handleApiError(error);
        callback({ error });
    }
};

export const fetchTag = async (tagId, callback) => {
    try {
        const response = await risapi.get(`/api/tags/${tagId}`, getAxiosConfig());
        if (response.status === 200) {
            callback(response.data);
        }
    } catch (error) {
        handleApiError(error);
        callback({ error });
    }
};

export const createTag = async (newTag, callback) => {
    try {
        const formData = convertJsonToFormData(newTag);
        const response = await risapi.post('/api/tags', formData, getAxiosConfig());
        if (response.status === 201) {
            callback(response.data);
        }
    } catch (error) {
        callback(error.response.data);
    }
};

export const updateTag = async (editTag, callback) => {
    try {
        const formData = convertJsonToFormData(editTag);
        formData.append('_method', 'put');
        
        const response = await risapi.post(`/api/tags/${editTag.id}`, formData, getAxiosConfig());
        if (response.status === 200) {
            callback(response.data);
        }
    } catch (error) {
        callback(error.response.data);
    }
};

export const destroyTag = async (deleteTag, callback) => {
    try {
        const response = await risapi.delete(`/api/tags/${deleteTag.id}`, getAxiosConfig());
        if (response.status === 204) {
            callback({ tag: deleteTag });
        }
    } catch (error) {
        handleApiError(error);
        callback({ error });
    }
};
